module.exports = __webpack_public_path__ + "static/media/100 Winners.46a1e0dc.png";